import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, ViewContainerRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProgressSpinnerComponent } from '../widgets/progress-spinner/progress-spinner.component';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading: boolean = false;

  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  // constructor() {}

  // getLoading(): boolean {
  //   return this.loading;
  // }

  private overlayRef: OverlayRef | null = null;

  constructor(private overlay: Overlay) {}

  // show(viewContainerRef?: ViewContainerRef) {
  //   if (!this.overlayRef) {
  //     this.overlayRef = this.overlay.create({
  //       hasBackdrop: true,
  //       backdropClass: 'cdk-overlay-dark-backdrop',
  //       positionStrategy: this.overlay
  //         .position()
  //         .global()
  //         .centerHorizontally()
  //         .centerVertically(),
  //     });

  //     const spinnerPortal = new ComponentPortal(
  //       ProgressSpinnerComponent,
  //       viewContainerRef
  //     );
  //     this.overlayRef.attach(spinnerPortal);
  //   }
  // }

  // hide() {
  //   if (this.overlayRef) {
  //     this.overlayRef.detach();
  //     this.overlayRef.dispose();
  //     this.overlayRef = null;
  //   }
  // }

  show() {
    this.loadingSubject.next(true);
  }

  hide() {
    this.loadingSubject.next(false);
  }

  setLoading(loading: boolean) {
    this.loading = loading;
    this.loadingSubject.next(loading); // update observable
  }

  getLoading(): boolean {
    return this.loadingSubject.getValue();
  }
}
